import React from 'react'
import SEO from '../seo'

export default function SEOBlock(props) {
  return (
    <SEO title={props?.node?.title} description={props?.node?.description} />
  )
}
